import { Avatar, Grid } from "@mui/material";
import React, { useState } from "react";
import { deepOrange, green } from "@mui/material/colors";
import Logo from "../../assets/images/brand-logo.png";
import { useNavigate } from "react-router-dom";

const LoginPage = () => {
  const navigate = useNavigate();
  const [inputArray, setInputArray] = useState([]);
  const initStyle = [
    { text: "", color: "#B1B1B1" },
    { text: "", color: "#B1B1B1" },
    { text: "", color: "#B1B1B1" },
    { text: "", color: "#B1B1B1" },
  ];
  const [inputStyle, setInputStyle] = useState(initStyle);

  const handleCirleInput = (idx) => {
    setInputStyle(
      inputStyle.map((item, index) =>
        idx == index ? { ...item, text: "*", color: "#0E5A41" } : item
      )
    );
  };

  const keyHandler = (props) => {
    let myValue = [...inputArray];
    if (props === "Clear") {
      setInputArray([]);
      setInputStyle(initStyle);
    } else if (props === "Login") {
      if (myValue.length == 4) {
        navigate("/nine-menu");
      }
    } else {
      if (myValue.length < 4) {
        setInputArray([...inputArray, props]);
        myValue = [...myValue, props];
        handleCirleInput(myValue.length - 1);
      }
    }
    // console.log("Array: " + inputArray);
    console.log("Array2: " + myValue);
  };

  return (
    <div>
      <Grid
        container
        direction="column"
        justifyContent="center"
        alignItems="center"
      >
        <BrandLogo />
        <div
          style={{
            width: 225,
            height: 50,
            marginTop: 20,
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
          }}
        >
          {[1, 2, 3, 4].map((info, index) => (
            <Circle info="*" inputStyle={inputStyle[index]} />
          ))}
        </div>

        <KeyBoardBox keyHandler={keyHandler} />
      </Grid>
    </div>
  );
};

const keyInfo = [
  { text: "1", action: "", bg: "transparent", fs: 36, color: "#535353" },
  { text: "2", action: "", bg: "transparent", fs: 36, color: "#535353" },
  { text: "3", action: "", bg: "transparent", fs: 36, color: "#535353" },
  { text: "4", action: "", bg: "transparent", fs: 36, color: "#535353" },
  { text: "5", action: "", bg: "transparent", fs: 36, color: "#535353" },
  { text: "6", action: "", bg: "transparent", fs: 36, color: "#535353" },
  { text: "7", action: "", bg: "transparent", fs: 36, color: "#535353" },
  { text: "8", action: "", bg: "transparent", fs: 36, color: "#535353" },
  { text: "9", action: "", bg: "transparent", fs: 36, color: "#535353" },
  { text: "Clear", action: "", bg: "#ED1B24", fs: 22, color: "#FFFFFF" },
  { text: "0", action: "", bg: "transparent", fs: 36, color: "#535353" },
  { text: "Login", action: "", bg: "#0E5A41", fs: 22, color: "#FFFFFF" },
];

const Circle = ({ info, inputStyle }) => (
  <div
    style={{
      border: `1px solid ${inputStyle.color}`,
      width: 45,
      height: 45,
      borderRadius: 25,
      fontSize: 40,
      color: inputStyle.color,
      fontWeight: "600",
    }}
  >
    {inputStyle.text}
  </div>
);

const BrandLogo = () => (
  <Avatar
    sx={{
      bgcolor: deepOrange[500],
      width: "150px",
      height: "82px",
      marginTop: 5,
    }}
    variant="square"
    src={Logo}
  />
);

const KeyBoardBox = ({ keyHandler }) => (
  <div
    style={{
      width: 379,
      height: 341,
      // border: "1px solid gray",
      marginTop: 20,
      boxShadow: "rgba(100, 100, 111, 0.2) 0px 7px 29px 0px",
    }}
  >
    <Grid
      container
      direction="row"
      justifyContent="space-around"
      alignItems="center"
    >
      {keyInfo.map((info, index) => (
        <SingleKey info={info} keyHandler={keyHandler} />
      ))}
    </Grid>
  </div>
);

const SingleKey = ({ info, keyHandler }) => (
  <div
    style={{
      marginTop: 10,
      border: "1.5px solid #E0E0E0",
      borderRadius: 4,
      width: 112,
      height: 70,
      display: "flex",
      flexDirection: "row",
      justifyContent: "center",
      alignItems: "center",
      color: info.color,
      fontSize: info.fs,
      background: info.bg,
      cursor: "pointer",
    }}
    onClick={() => keyHandler(info.text)}
  >
    {info.text}
  </div>
);

export default LoginPage;
